import { createContext, useContext, useState, type ReactNode } from "react";
import { cargarCatalogo, guardarIdioma, idiomaInicial, type Idioma } from "./i18n";

type Tema = "claro" | "oscuro";
type Preferencias = { idioma: Idioma; setIdioma: (i: Idioma) => void; tema: Tema; setTema: (t: Tema) => void };

const Ctx = createContext<Preferencias | null>(null);

function temaInicial(): Tema {
  return document.documentElement.classList.contains("dark") ? "oscuro" : "claro";
}

export function PreferenciasProvider({ children }: { children: (idioma: Idioma) => ReactNode }) {
  const [idioma, setIdiomaState] = useState<Idioma>(idiomaInicial);
  const [tema, setTemaState] = useState<Tema>(temaInicial);

  // El catálogo llega antes del cambio: nunca se pinta una pantalla con claves sin traducir.
  const setIdioma = (i: Idioma) => {
    void cargarCatalogo(i).then(() => {
      guardarIdioma(i);
      setIdiomaState(i);
    });
  };
  const setTema = (t: Tema) => {
    document.documentElement.classList.toggle("dark", t === "oscuro");
    try { localStorage.setItem("responia.tema", t); } catch {}
    setTemaState(t);
  };

  return <Ctx.Provider value={{ idioma, setIdioma, tema, setTema }}>{children(idioma)}</Ctx.Provider>;
}

export function usePreferencias() {
  const v = useContext(Ctx);
  if (!v) throw new Error("usePreferencias fuera de PreferenciasProvider");
  return v;
}
